import { ref, firebaseAuth } from "config/constants";
import * as messages from "data/messages/actions";
import {
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_RESET_REQUEST,
  AUTH_RESET_SUCCESS,
  AUTH_RESET_FAILURE,
  AUTH_REGISTER_REQUEST,
  AUTH_REGISTER_SUCCESS,
  AUTH_REGISTER_FAILURE,
  AUTH_SIGNOUT_SUCCESS,
  AUTH_SIGNOUT_FAILURE,
  AUTH_AUTHORIZED,
  AUTH_CONNECTED_USER,
  AUTH_CONNECTED_ACCOUNT,
  AUTH_RESET_ACTIVATION_CODE_REQUEST,
  AUTH_RESET_ACTIVATION_CODE_SUCCESS,
  AUTH_RESET_ACTIVATION_CODE_FAILURE,
} from "./types";

const Users = ref.child("users");
const Accounts = ref.child("accounts");

export function getAuthUser() {
  return dispatch => {
    return firebaseAuth().onAuthStateChanged(fbuser => {
      dispatch({
        type: AUTH_AUTHORIZED,
        payload: fbuser
      });

      if (fbuser) {
        Users.child(fbuser.uid).on("value", snapshot => {
          var user = snapshot.val();
          if (user) {
            dispatch({
              type: AUTH_CONNECTED_USER,
              payload: user
            });

            Accounts.child(user.info.accountid).on("value", snapshot => {
              dispatch({
                type: AUTH_CONNECTED_ACCOUNT,
                payload: snapshot.val()
              });
            });
          }
        });
      }
    });
  };
}

export function register(email, phone, pw) {
  return dispatch => {
    dispatch({
      type: AUTH_REGISTER_REQUEST
    });

    return firebaseAuth()
      .createUserWithEmailAndPassword(email, pw)
      .then(createUserAccount)
      .then(user => { user.phone = phone; return user;})
      .then(saveUser)
      .then(user => {
        dispatch({
          type: AUTH_REGISTER_SUCCESS,
          payload: user
        });

        dispatch(
          messages.showMessage(`Hej ${email}, du har nu skapat ett konto!`)
        );
      })
      .catch(error => {
        dispatch({
          type: AUTH_REGISTER_FAILURE,
          payload: error
        });
        dispatch(messages.showMessage(error.message));
      });
  };
}

export function logout() {
  return dispatch => {
    return firebaseAuth()
      .signOut()
      .then(user => {
        dispatch({
          type: AUTH_SIGNOUT_SUCCESS,
          payload: user
        });
      })
      .catch(error => {
        console.log(error);
        dispatch({
          type: AUTH_SIGNOUT_FAILURE,
          payload: error
        });
      });
  };
}

export function login(email, pw) {
  return dispatch => {
    dispatch({
      type: AUTH_LOGIN_REQUEST
    });

    return firebaseAuth()
      .signInWithEmailAndPassword(email, pw)
      .then(user => {
        dispatch({
          type: AUTH_LOGIN_SUCCESS,
          payload: user
        });

        dispatch(messages.showMessage(`Hej ${email}, du är nu inloggad!`));
      })
      .catch(error => {
        dispatch({
          type: AUTH_LOGIN_FAILURE,
          payload: error
        });
        switch (error.code) {
          case "auth/invalid-email":
          dispatch(messages.showMessage("Du måste logga in med en giltigt epost-adress."));
          break;
          case "auth/operation-not-allowed":
          case "auth/wrong-password":
          dispatch(messages.showMessage("Inloggningen misslyckades."));
          break;
          case "auth/user-not-found":
          dispatch(messages.showMessage("Det finns inget koto registrerat på denna epost-adress."));
          break;
        default:
            dispatch(messages.showMessage(error.message));

        }
      });
  };
}

export function reset(email) {
  return dispatch => {
    dispatch({
      type: AUTH_RESET_REQUEST
    });

    return firebaseAuth()
      .sendPasswordResetEmail(email)
      .then(user => {
        dispatch({
          type: AUTH_RESET_SUCCESS,
          payload: user
        });

        dispatch(messages.showMessage(`Vi har nu skickat ett mail till ${email} med instruktioner.`));
      })
      .catch(error => {
        dispatch({
          type: AUTH_RESET_FAILURE,
          payload: error
        });
        dispatch(messages.showMessage(error.message));
      });
  };
}

export function saveUserInfo(userInfo) {
  console.log("saveUserInfo", userInfo)
  return dispatch => {
    dispatch({
      type: AUTH_RESET_ACTIVATION_CODE_REQUEST
    });

    return Users.child(`${userInfo.uid}/info`)
      .set({
        email: userInfo.email,
        phone: userInfo.phone,
        uid: userInfo.uid,
        accountid: userInfo.accountid
      })
      .then(() => userInfo);
  }
}

export function saveUser(user) {
  console.log("saveUser", user)
  var userData = 
  {
    info: { 
        email: user.email,
        phone: user.phone,
        uid: user.uid,
        accountid: user.accountid
    } 
  }
  console.log(userData)
  if (userData.info.phone)
  {
    userData.activation = { secret: Math.floor(Math.random() * 1000000) }
  }

  return Users.child(`${user.uid}`)
    .set(userData)
    .then(() => user)
}


export function resetActivationCode(user) {
  return dispatch => {
    dispatch({
      type: AUTH_RESET_ACTIVATION_CODE_REQUEST
    });

    return Users.child(`${user.uid}/activation/secret`)
      .set(Math.floor(Math.random() * 1000000)  )
      .then(user => {
        dispatch({
          type: AUTH_RESET_ACTIVATION_CODE_SUCCESS,
          payload: user
        });

        dispatch(messages.showMessage(`Vi har nu skickat ett sms med en aktiveringskod.`));
      })
      .catch(error => {
        dispatch({
          type: AUTH_RESET_ACTIVATION_CODE_FAILURE,
          payload: error
        });
        dispatch(messages.showMessage(error.message));
      });
  };
}

export function saveUserActivationCode(user) {
  return ref
    .child(`users/${user.uid}/activation/secret`)
    .set(Math.floor(Math.random() * (999999 - 100000) + 100000)  )
    .then(() => user);
}

export function createUserAccount(user) {
  return ref
    .child(`accounts`)
    .push({
      admin: user.uid,
      users: { [user.uid]: { role: "admin", registered: new Date().getTime() } }
    })
    .then(snap => {
      user.accountid = snap.key;
    })
    .then(() => user);
}



// WEBPACK FOOTER //
// ./src/data/auth/actions.js